module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-regular-400.eot?8482fbfddf05016010eaf2aebcc95250";